module.exports = __webpack_public_path__ + "static/media/ph.be0243b3.bmp";